import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useHoverable } from "@gemini/core";
import { ArrowRightIcon, MoneyCheckDollarPenIcon } from "@gemini/icons";
import { PartnerBoxLogo } from "../../PartnerBoxAds/PartnerBoxLogo";
import { useI18n } from "@/shared/hooks";
import { useTrackingProductClick } from "@/hooks";
import { useClassified } from "@/contexts/classified";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const PartnerBoxAds = ({ partner }) => {
    var _a, _b;
    const { t } = useI18n();
    const partnerAd = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.sections) === null || _b === void 0 ? void 0 : _b.partnerAd;
    if (!partner || !(partnerAd === null || partnerAd === void 0 ? void 0 : partnerAd.showPartnerAd))
        return null;
    return (_jsx(Box, { marginTop: "spacing.16", children: _jsxs(AdButtonCard, { partnerName: partner.name, url: partner.url, pageViewGA4: partner.pageViewGA4, children: [_jsx(AdLogo, { children: partner.withLogo ? (_jsx(PartnerBoxLogo, { partnerKey: partner.name })) : (_jsx(MoneyCheckDollarPenIcon, {})) }), _jsx(AdTitle, { children: t(partner.text) }), _jsx(AdArrowRightIcon, {})] }) }));
};
const AdButtonCard = (props) => {
    const { boxProps } = useHoverable();
    const handleTrackingProductClick = useTrackingProductClick(props.partnerName);
    const isPreviewMode = useIsPreviewMode();
    const handleLinkClick = () => {
        if (isPreviewMode)
            return;
        handleTrackingProductClick();
        // eslint-disable-next-line no-restricted-globals
        window.open(props.url, "_blank");
    };
    const styleProps = {
        paddingHorizontal: "spacing.12",
        paddingVertical: "spacing.8",
        backgroundColor: "color.background.light",
        borderColor: "transparent",
        borderRadius: "radius.8",
    };
    return (_jsx(Box, Object.assign({ as: "button" }, boxProps, { onClick: handleLinkClick, display: "flex", flexDirection: "row", width: "100%" }, styleProps, { cursor: "pointer", children: props.children })));
};
const AdLogo = ({ children }) => (_jsx(Box, { alignSelf: "center", children: children }));
const AdTitle = ({ children }) => (_jsx(Box, { alignSelf: "center", paddingLeft: "spacing.8", typography: "typography.body.16.regularUnderlined", textAlign: "left", children: children }));
const AdArrowRightIcon = () => (_jsx(Box, { alignSelf: "center", flexGrow: "1", textAlign: "right", children: _jsx(ArrowRightIcon, { opacity: "opacity.70" }) }));
